import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { BondsPanel } from './BondsPanel';
import { emoteSystem } from './emotes';
import { EmotesPanel } from './EmotesPanel';
import { bondRewardSystem, bondsGame } from './runtime';
import './bonds.css';

/**
 * Bonds (NPC rapport: songs, emotes, gifts, stage rewards) and the emote
 * wheel. `playEmote(zone, actorId, emoteId)` plays an emote on any actor,
 * for replicated emotes from other players.
 */

let installedOn: Game | null = null;

export function install(game: Game): void {
  if (installedOn === game) return;
  installedOn = game;
  bondsGame.current = game;
  registerPanel('bonds', BondsPanel);
  registerPanel('emotes', EmotesPanel);
  game.systems.push(emoteSystem, bondRewardSystem);
}

export { playEmote, stopEmote, performPlayerEmote } from './emotes';
export { EMOTES, SONGS, PROFILES, bondNpcs, type EmoteId } from './data';
export { playSong, emoteFor, giveGift, claimStageRewards, stageRewards, dailyUsed } from './logic';
